<!-- Adapted from Koel ScreenBase.vue, 40183ac (MIT, Copyright (c) 2015 Phan An).
     Header/content slot hierarchy retained. Host owns scrolling; no Koel router, plugin hooks or header observer. -->
<template>
  <section class="koel-screen-base" data-upstream-component="Koel/ScreenBase">
    <div class="header-host"><slot name="header" /></div>
    <div class="screen-content"><slot /></div>
  </section>
</template>
<script>
export default { name: 'KoelScreenBase' };
</script>
<style scoped>
.koel-screen-base { display: flex; flex-direction: column; width: 100%; min-width: 0; color: var(--salt-text, var(--color-text)); }
.header-host { flex-shrink: 0; }
.screen-content { display:flex; flex-direction:column; min-width:0; padding:8px 0 0; }
</style>
